<div class="circ-document-upload-wrapper">
  <kendo-uploaddropzone zoneId="myZone">
    <div class="info-container">
      <kendo-icon [name]="'warning'" class="warning" themeColor="warning"></kendo-icon>
      {{ "circ.details.documents.addDocument" | i18n }}
      <br />
      <kendo-icon [name]="'information'" class="information"></kendo-icon
      >{{ "circ.details.documents.maxSize" | i18n }}
    </div>
  </kendo-uploaddropzone>
  <kendo-upload
    zoneId="myZone"
    *ngIf="uploadSettings$ | async"
    #upload
    [saveUrl]="(uploadSettings$ | async).saveUrl"
    [removeUrl]="(uploadSettings$ | async).removeUrl"
    [autoUpload]="false"
    (upload)="onUploadStart($event)"
    (complete)="onUploadComplete(upload)"
    (error)="onUploadError($event)"
    [restrictions]="(uploadSettings$ | async).restrictions"
  >
    <kendo-upload-messages
      [select]="'circ.document.upload.wrapper.select' | i18n"
      [uploadSelectedFiles]="
        'circ.document.upload.wrapper.uploadSelectedFiles' | i18n
      "
      [clearSelectedFiles]="
        'circ.document.upload.wrapper.clearSelectedFiles' | i18n
      "
    >
    </kendo-upload-messages>
  </kendo-upload>
  <div></div>
</div>
